import React from 'react';
import Calender from './calendar/index';

function CalenderTabs() {
    return <Calender />;
}

export default React.memo(CalenderTabs);
